// extracted by mini-css-extract-plugin
export default {"deleteWrap":"GroupDetail_deleteWrap__wRmcD"};